import { Services } from "appworks/services/services";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";

export class IsAutoplay extends Decision {
    public evaluate() {
        return Services.autoplay.isAutoPlaying() ? Exit.True : Exit.False;
    }
}
